
var pushManager = (deviceInfo, goScreenCallback) => {
    var _obj = {};
    var pushToken = "";
    var deviceUUID = "";
    var deviceName = "";
    var device = deviceInfo;

    _obj.goScreen = async (type, param1, param2, param3, param4) => {
        if(type == '') return;
        goScreenCallback(type, param1, param2, param3, param4);
    };

    _obj.setPushToken = (token) =>{
        pushToken = token;
    };

    _obj.setUuid = (uuid) => {
        deviceUUID = uuid;
    };

    _obj.setDeviceName = (devName) => {
        deviceName = devName;
    }

    //ios만
    _obj.getUuid = async() => {
        // var device = this.$cookies.get("device");
        if(device == 'android'){
            deviceUUID = window.Android.getUuid();
        }else if(device == 'ios') {
            /*eslint-disable no-undef */
            webkit.messageHandlers.ios.postMessage({cmd : 'setUuid'});
            await waitMiliSeconds(100);
        }

        return deviceUUID;
    };

    _obj.getPushToken = async () => {
        // var device = this.$cookies.get("device");
        if(device == 'android'){
            pushToken = window.Android.getPushToken();
        }else if(device == 'ios'){
            /*eslint-disable no-undef */
            webkit.messageHandlers.ios.postMessage({cmd : 'setPushToken'});
            await waitMiliSeconds(100);
        }
        return pushToken;
    };

    _obj.getDeviceName = async () => {
        // var device = this.$cookies.get("device");
        if(device == 'android'){
            deviceName = "";
        }else if(device == 'ios'){
            /*eslint-disable no-undef */
            webkit.messageHandlers.ios.postMessage({cmd : 'setDeviceName'});
            await waitMiliSeconds(100);
        }
        return deviceName;
    };

    _obj.detectPushArrivedWhenActive = async(type, param1, param2, param3, param4) => {
        type;param1;param2;param3;param4;
        // alert(type + ',' + param1 + ',' + param2 + ',' + param3 + ',' + param4);
        console.log('detectPushArrivedWhenActive');
        // alert('푸시 arrvied');
    }

    function waitMiliSeconds(time) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, time);
        });
    }

    return _obj;
}

export default pushManager;